import { render, staticRenderFns } from "./deleteNotepad.vue?vue&type=template&id=e52884a8&scoped=true"
import script from "./deleteNotepad.vue?vue&type=script&lang=js"
export * from "./deleteNotepad.vue?vue&type=script&lang=js"
import style0 from "./deleteNotepad.vue?vue&type=style&index=0&id=e52884a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52884a8",
  null
  
)

export default component.exports